<template>
  <BaseSelectSimple
    v-if="metadata && metadata.customers"
    :key="model[name]"
    :label="$t('attributes.customer')"
    :placeholder="$t('attributes.customer')"
    :name="name"
    :default-value="metadata.customers.filter((el) => el.id === model[name])"
    :options="metadata.customers"
    :disabled="permission"
    :errors="errors[name]"
    @set-selected="getInputValue"
  />
</template>
<script>
import BaseSelectSimple from './BaseSelectSimple.vue'

export default {
  name: 'SelectCustomer',
  components: { BaseSelectSimple },
  props: {
    errors: {},
    model: {},
    permission: {},
    getInputValue: {},
    metadata: { type: Object },
    name: { type: String, required: false, default: 'customer_id' }
  }
}
</script>
